import { render, staticRenderFns } from "./VideoCallInvitationTool.vue?vue&type=template&id=15327dd3&scoped=true&"
import script from "./VideoCallInvitationTool.vue?vue&type=script&lang=ts&"
export * from "./VideoCallInvitationTool.vue?vue&type=script&lang=ts&"
import style0 from "./VideoCallInvitationTool.vue?vue&type=style&index=0&id=15327dd3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15327dd3",
  null
  
)

export default component.exports